import api from 'api';
import { useSearchParams } from 'hooks/useSearchParams';
import { useMutation, useQueryClient } from 'react-query';
import { AppError } from 'utils/AppError';
import { salaryComponentParams } from '../constants';
import { SalaryComponent } from '../types';
import listPerquisitesComponents from 'api/gql-utils/perquisitesComponents/listPerquisitesComponents';

type UseModalActionsProps = {
  modalAction: string | null;
  salaryComponent: SalaryComponent;
  onSuccess?: () => void;
  onError?: (error: AppError) => void;
};

export const useModalActions = ({
  modalAction,
  salaryComponent,
  onSuccess,
  onError,
}: UseModalActionsProps) => {
  const { urlParams } = useSearchParams();
  const salaryComponentId = urlParams.get(salaryComponentParams.componentId) || '';
  const queryClient = useQueryClient();

  const actionMutation = useMutation(
    async (params: any): Promise<any> => {
      if (salaryComponent.category === 'PERQUISITES_CATEGORY') {
        const status = params.status === 'SET_STATUS_ACTIVE' ? 'active' : 'inactive';
        return await api.salaryComponents.mutations.editPerquisitesComponent({
          components: [
            {
              id: salaryComponentId,
              name: salaryComponent.name,
              displayName: salaryComponent.displayName,
              description: salaryComponent.description || '',
              showZero: salaryComponent.showZero || false,
              visibleToEmployee: salaryComponent?.visibleToEmployee || false,
              status: status as 'active' | 'inactive',
            },
          ],
        });
      }

      return await api.salaryComponents.mutations.setSalaryComponentStatus(params);
    },
    {
      onSuccess: () => {
        if (salaryComponent.category === 'PERQUISITES_CATEGORY') {
          queryClient.invalidateQueries([listPerquisitesComponents]);
        }
        onSuccess && onSuccess();
      },
      onError(error: AppError) {
        onError && onError(error);
      },
    },
  );

  return {
    salaryComponentId,
    modalAction,
    actionMutation,
  };
};
